/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMemberFieldTypes } from './WebApiModelsEnumerationTypesMemberFieldTypes';
import {
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSON,
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSONTyped,
    WebApiModelsEnumerationTypesMemberFieldTypesToJSON,
} from './WebApiModelsEnumerationTypesMemberFieldTypes';

/**
 * Represents a column configuration within a view
 * @export
 * @interface WebApiModelsViewColumn
 */
export interface WebApiModelsViewColumn {
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsViewColumn
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsViewColumn
     */
    viewId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsViewColumn
     */
    sortOrder?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberFieldTypes}
     * @memberof WebApiModelsViewColumn
     */
    columnType?: WebApiModelsEnumerationTypesMemberFieldTypes;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsViewColumn
     */
    customFieldId?: number | null;
}

/**
 * Check if a given object implements the WebApiModelsViewColumn interface.
 */
export function instanceOfWebApiModelsViewColumn(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiModelsViewColumnFromJSON(json: any): WebApiModelsViewColumn {
    return WebApiModelsViewColumnFromJSONTyped(json, false);
}

export function WebApiModelsViewColumnFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsViewColumn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'viewId': !exists(json, 'viewId') ? undefined : json['viewId'],
        'sortOrder': !exists(json, 'sortOrder') ? undefined : json['sortOrder'],
        'columnType': !exists(json, 'columnType') ? undefined : WebApiModelsEnumerationTypesMemberFieldTypesFromJSON(json['columnType']),
        'customFieldId': !exists(json, 'customFieldId') ? undefined : json['customFieldId'],
    };
}

export function WebApiModelsViewColumnToJSON(value?: WebApiModelsViewColumn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'viewId': value.viewId,
        'sortOrder': value.sortOrder,
        'columnType': WebApiModelsEnumerationTypesMemberFieldTypesToJSON(value.columnType),
        'customFieldId': value.customFieldId,
    };
}

